import PropTypes from 'prop-types'
import {
  Panel,
  PanelBody,
  PanelContent,
  PanelTitle,
} from './PagePanel.styles'

/**
 * Canonical content card for settings / help / account pages.
 */
const PagePanel = ({
  id,
  title,
  body,
  children,
  highlighted = false,
}) => (
  <Panel id={id} $highlighted={highlighted}>
    {title ? <PanelTitle>{title}</PanelTitle> : null}
    {body ? <PanelBody>{body}</PanelBody> : null}
    {children ? <PanelContent>{children}</PanelContent> : null}
  </Panel>
)

PagePanel.propTypes = {
  id: PropTypes.string,
  title: PropTypes.node,
  body: PropTypes.node,
  children: PropTypes.node,
  highlighted: PropTypes.bool,
}

export default PagePanel
export { PageStack, Panel, PanelTitle, PanelBody, PanelContent } from './PagePanel.styles'
